import { render, staticRenderFns } from "./DistributorActivate.vue?vue&type=template&id=2c553e28&"
import script from "./DistributorActivate.vue?vue&type=script&lang=js&"
export * from "./DistributorActivate.vue?vue&type=script&lang=js&"
import style0 from "./DistributorActivate.vue?vue&type=style&index=0&id=2c553e28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports